import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../../layout/MainContainer";
import {
  Box,
  Button,
  Tab,
  Tabs,
  Grid,
  Typography,
  CardMedia,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import RejectReasonModal from "../../../Modals/rejectReason";
import TableComponent from "../../../components/TableComponent";
import { useLazyGetUsersByIdQuery } from "../../../services/customer";
import { showError } from "../../../constants/toasts";
import { useLazyGetBookingQuery } from "../../../services/booking";
import { Booking } from "../../../types/General";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const venueColumns = [
  { field: "name", headerName: "Venue Name", flex: 1, minWidth: 150 },
  { field: "date", headerName: "Booking Date", flex: 1, minWidth: 150 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
  { field: "amount", headerName: "Amount", flex: 1, minWidth: 100 },
];
const storageColumns = [
  { field: "name", headerName: "Storage Name", flex: 1, minWidth: 150 },
  { field: "date", headerName: "Booking Date", flex: 1, minWidth: 150 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
  { field: "amount", headerName: "Amount", flex: 1, minWidth: 100 },
];

const ManageOwnerDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [open, setOpen] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [selectedImageTitle, setSelectedImageTitle] = useState<string>("");

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleImageClick = (imageUrl: string, title: string) => {
    setSelectedImage(imageUrl);
    setSelectedImageTitle(title);
    setImageModalOpen(true);
  };

  const handleCloseImageModal = () => {
    setImageModalOpen(false);
    setSelectedImage("");
    setSelectedImageTitle("");
  };
  // Booking History sub-tabs
  const [bookingTab, setBookingTab] = useState(0);
  const handleBookingTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setBookingTab(newValue);
    setPage(1);
  };
  const [UserDetails] = useLazyGetUsersByIdQuery();
  const [loading, setLoading] = useState(false);
  const [owner, setOwner] = useState<any>(null);
  const [getBookingApi] = useLazyGetBookingQuery();
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [bookingData, setBookingData] = useState<Booking[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const getDataByIdList = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const response = await UserDetails({ id }).unwrap();
      if (response.statusCode === 200) {
        setOwner(response.data);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };
  const getBookngApi = async () => {
    setLoading(true);
    try {
      const response = await getBookingApi({
        from: page,
        search: debouncedSearchTerm,
        size: 10,
        type: bookingTab === 0 ? "VENUE" : "STORAGE",
        ownerId: id as string,
        status: "",
      } as any).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setBookingData(response?.data?.data || []);
        setCount(response?.data?.total || 0);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getDataByIdList();
    }
  }, [id]);
  useEffect(() => {
    if (id) {
      getBookngApi();
    }
  }, [id, bookingTab, page, debouncedSearchTerm]);
  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>Owner Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-customers")}>
              Manage Owner
            </span>{" "}
            - Owner Detail
          </p>
        </div>
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="General Details" {...a11yProps(0)} />
                <Tab label="Booking History" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Personal Details</h2>
            </div>
            <div className="gap_p">
              <div className="vew_img w_100">
                <h6>Image</h6>
                <figure>
                  <img
                    alt="owner"
                    src={
                      owner?.profileImage ||
                      owner?.image ||
                      "/static/images/user_placeholder.png"
                    }
                    onError={(e) => {
                      e.currentTarget.src =
                        "/static/images/user_placeholder.png";
                    }}
                  />
                </figure>
              </div>
              <div className="w_33">
                <h6>First Name</h6>
                <p>{owner?.firstName || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Middle Name</h6>
                <p>{owner?.middleName || "N/A"}</p>
              </div>
              
              <div className="w_33">
                <h6>Last Name</h6>
                <p>{owner?.lastName || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Email Id</h6>
                <p>{owner?.email || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Phone Number</h6>
                <p>
                  {owner?.countryCode && owner?.phoneNumber
                    ? `${owner.countryCode} ${owner.phoneNumber}`
                    : "N/A"}
                </p>
              </div>
              
              <div className="w_33">
                <h6>Email Verified</h6>
                <p>{owner?.isEmailVerified ? "Yes" : "No"}</p>
              </div>
              <div className="w_33">
                <h6>Phone Verified</h6>
                <p>{owner?.isPhoneVerified ? "Yes" : "No"}</p>
              </div>
              {/* <div className="w_33">
                <h6>Profile Completed</h6>
                <p>{owner?.isProfileCompleted ? "Yes" : "No"}</p>
              </div> */}
              {/* <div className="w_33">
                <h6>Account Status</h6>
                <p>{owner?.accountStatus || "N/A"}</p>
              </div> */}
              <div className="w_33">
                <h6>Status</h6>
                <p>{owner?.status ? "Active" : "Inactive"}</p>
              </div>
              {/* <div className="w_33">
                <h6>Social Login</h6>
                <p>{owner?.isSocialLogin ? "Yes" : "No"}</p>
              </div> */}
              <div className="w_33">
                <h6>Created At</h6>
                <p>
                  {owner?.createdAt
                    ? new Date(owner.createdAt).toLocaleDateString()
                    : "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* Documents Section */}
          <div className="cards view_page">
            <div className="single_doc">
              <Grid container spacing={2}>
                <Grid item xs={12} className="heading">
                  <Typography className="document_head" variant="h5">
                    National ID Documents
                  </Typography>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div className="control_group">
                    <Typography className="custom_label">Front Side</Typography>
                    <Box className="docs_div v2">
                      <div
                        className="upload_image no_radius v2"
                        onClick={() =>
                          handleImageClick(
                            owner?.nationalId?.frontSide ||
                              "/static/images/picture.png",
                            "National ID Front Side"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia
                              component="img"
                              image={
                                owner?.nationalId?.frontSide ||
                                "/static/images/picture.png"
                              }
                              alt="National ID Front"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "200px",
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.currentTarget.src =
                                  "/static/images/picture.png";
                              }}
                            />
                          </figure>
                        </div>
                      </div>
                    </Box>
                  </div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div className="control_group">
                    <Typography className="custom_label">Back Side</Typography>
                    <Box className="docs_div v2">
                      <div
                        className="upload_image no_radius v2"
                        onClick={() =>
                          handleImageClick(
                            owner?.nationalId?.backSide ||
                              "/static/images/picture.png",
                            "National ID Back Side"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia
                              component="img"
                              image={
                                owner?.nationalId?.backSide ||
                                "/static/images/picture.png"
                              }
                              alt="National ID Back"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "200px",
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.currentTarget.src =
                                  "/static/images/picture.png";
                              }}
                            />
                          </figure>
                        </div>
                      </div>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </div>

            <div className="single_doc">
              <Grid container spacing={2}>
                <Grid item xs={12} className="heading">
                  <Typography className="document_head" variant="h5">
                    Space Proof Document
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <div className="control_group">
                    <Typography className="custom_label">
                      Space Proof
                    </Typography>
                    <Box className="docs_div v2">
                      <div
                        className="upload_image no_radius v2"
                        onClick={() =>
                          handleImageClick(
                            owner?.spaceProof || "/static/images/picture.png",
                            "Space Proof Document"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia
                              component="img"
                              image={
                                owner?.spaceProof ||
                                "/static/images/picture.png"
                              }
                              alt="Space Proof"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "300px",
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.currentTarget.src =
                                  "/static/images/picture.png";
                              }}
                            />
                          </figure>
                        </div>
                      </div>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={bookingTab}
                onChange={handleBookingTabChange}
                aria-label="booking history tabs"
                className="custom_tabs_links"
              >
                <Tab label="Venue" />
                <Tab label="Storage" />
              </Tabs>
            </Box>
            <CustomTabPanel value={bookingTab} index={0}>
              <div className="sorting_table">
                <TableComponent
                  columns={venueColumns}
                  rows={(bookingData || []).map((b: any) => ({
                    ...b,
                    name: b?.venueStorage?.name || "-",
                    date:
                      b?.from
                        ? moment(b?.from).isSame(b?.to, "day")
                          ? moment(b?.from).format("MMM DD")
                          : `${moment(b?.from).format("MMM DD")} - ${moment(
                              b?.to
                            ).format("MMM DD")}`
                        : "-",
                    status: b?.bookingStatus || "-",
                    amount: `$${b?.totalAmount || 0}`,
                  }))}
                  count={count}
                  page={page}
                  onPageChange={(e: any, newPage: number) => handlePageChange(e, newPage)}
                  loading={loading}
                />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={bookingTab} index={1}>
              <div className="sorting_table">
                <TableComponent
                  columns={storageColumns}
                  rows={(bookingData || []).map((b: any) => ({
                    ...b,
                    name: b?.venueStorage?.name || "-",
                    date:
                      b?.from
                        ? moment(b?.from).isSame(b?.to, "day")
                          ? moment(b?.from).format("MMM DD")
                          : `${moment(b?.from).format("MMM DD")} - ${moment(
                              b?.to
                            ).format("MMM DD")}`
                        : "-",
                    status: b?.bookingStatus || "-",
                    amount: `$${b?.totalAmount || 0}`,
                  }))}
                  count={count}
                  page={page}
                  onPageChange={(e: any, newPage: number) => handlePageChange(e, newPage)}
                  loading={loading}
                />
              </div>
            </CustomTabPanel>
          </div>
        </CustomTabPanel>
      </MainContainer>
      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onSubmit={() => {}}
      />

      {/* Image View Modal */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          display: imageModalOpen ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
        onClick={handleCloseImageModal}
      >
        <Box
          sx={{
            position: "relative",
            maxWidth: "90%",
            maxHeight: "90%",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Typography
            variant="h6"
            sx={{
              marginBottom: "15px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {selectedImageTitle}
          </Typography>
          <img
            src={selectedImage}
            alt={selectedImageTitle}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
              borderRadius: "4px",
            }}
            onError={(e) => {
              e.currentTarget.src = "/static/images/placeholder.png";
            }}
          />
          <Button
            onClick={handleCloseImageModal}
            sx={{
              marginTop: "15px",
              backgroundColor: "#1976d2",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ManageOwnerDetail;
